import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, SectionGroup } from '@bingads-webui-cc-react/layout';
import type { CheckInstructionSectionProps } from './types';

function CheckInstructionSectionUnwrapped({
  i18n,
  payee,
  mailingAddress,
  expressMailingAddress,
}: CheckInstructionSectionProps) {
  return (
    <SectionGroup name="check-instruction" title={i18n.getString(_TL_('Check instructions'))}>
      {payee && (
        <FormGroup id="payee" label={i18n.getString(_TL_('Make payments to'))}>
          {payee}
        </FormGroup>
      )}
      {mailingAddress && (
        <FormGroup id="mail-address" label={i18n.getString(_TL_('Send check to'))}>
          {mailingAddress}
        </FormGroup>
      )}
      {expressMailingAddress && (
        <FormGroup id="express-mail-address" label={i18n.getString(_TL_('Express mail'))}>
          {expressMailingAddress}
        </FormGroup>
      )}
      <FormGroup id="check-what-to-expect" label={i18n.getString(_TL_('What to expect'))}>
        {i18n.getString(_TL_('It can take between 7 and 14 days after you mail your check for the funds to appear in your Microsoft Advertising account.'))}
      </FormGroup>
    </SectionGroup>
  );
}

CheckInstructionSectionUnwrapped.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  payee: PropTypes.string,
  mailingAddress: PropTypes.string,
  expressMailingAddress: PropTypes.string,
};

CheckInstructionSectionUnwrapped.defaultProps = {
  payee: '',
  mailingAddress: '',
  expressMailingAddress: '',
};

export const CheckInstructionSection = memo(CheckInstructionSectionUnwrapped);
